<script>
import webservices from '@/utils/webservice'
import moment from 'moment'

moment.locale('es')

export default {
  name: 'TimeLineComponent',
  data () {
    return {
      active: true,
      timeline: {},
      loading: false
    }
  },
  mounted () {
    this.loadTimeline()
  },
  methods: {
    loadTimeline () {
      this.loading = true
      webservices.publications.getHistory().then(history => {
        if (history !== null) {
          let timelined = {}
          history.forEach(entry => {
            entry.timestamp = entry.timestamp * 1000
            let date = moment(entry.timestamp).format('LL')
            if (!timelined.hasOwnProperty(date)) {
              timelined[date] = []
            }
            timelined[date].push(entry)
          })
          let finalTimeline = []
          for (let key in timelined) {
            // noinspection JSUnfilteredForInLoop
            finalTimeline.push({type: 'dateKey', value: key})
            // noinspection JSUnfilteredForInLoop
            timelined[key].forEach(entry => {
              finalTimeline.push({type: 'entry', value: entry})
            })
          }
          this.loading = false
          this.timeline = finalTimeline
        }
      })
    },
    elapsedTime (timestamp) {
      return `${moment(timestamp).format('LT')} (${moment(timestamp).fromNow()})`
    },
    urlForImage (imagePath) {
      return `${process.env.PICTURE_ENDPOINT}/${imagePath}`
    }
  }
}
</script>

<template>
  <div>
  <section class="content-header">

    <button class="btn btn-warning" v-on:click="loadTimeline" style="float: right; clear:both;">Actualizar</button>
    <br /><br />
    <!--<h1>-->
      <!--Timeline-->
      <!--<small>últimos movimientos en publicaciones de vehículos</small>-->

    <!--</h1>-->
  </section>
    <div style="position:relative; width: 100%; text-align: center; height: auto !important;">
      <div class="overlay" v-if="loading" style="margin: 0 auto; min-height: auto !important;">
        <i class="fa fa-refresh fa-spin"></i>
      </div>
    </div>
  <section class="content">

    <div class="container">

      <!-- basic data vehicle box -->
      <div class="box box-default box-basic-data">

        <!-- /.box-header -->
        <!-- .box-body -->
        <div class="box-body">
          <ul class="timeline timeline-inverse">
            <!-- timeline time label -->
            <li v-bind:class="{'time-label': entry.type === 'dateKey'}" v-for="(entry, key) in timeline" v-bind:key="key">
                <span class="bg-red" v-if="entry.type === 'dateKey'">
                  {{entry.value}}
                </span>

                <i class="fa fa-rss badge_publish" v-if="entry.type === 'entry' && entry.value.action === 'PUBLISH'"></i>
                <i class="fa fa-car badge_create_vehicle" v-if="entry.type === 'entry' && entry.value.action === 'CREATE_VEHICLE'"></i>
                <i class="fa fa-pencil badge_update_vehicle" v-if="entry.type === 'entry' && entry.value.action === 'UPDATE_VEHICLE'"></i>
                <i class="fa fa-power-off badge_unpublish" v-if="entry.type === 'entry' && entry.value.action === 'UNPUBLISH'"></i>
                <i class="fa fa-ticket badge_reserve" v-if="entry.type === 'entry' && entry.value.action === 'RESERVE'"></i>
                <i class="fa fa-eraser badge_remove_reserve" v-if="entry.type === 'entry' && entry.value.action === 'DELETE_RESERVE'"></i>
                <i class="fa fa-dollar badge_sold" v-if="entry.type === 'entry' && entry.value.action === 'SOLD'"></i>

                <div class="timeline-item" v-if="entry.type === 'entry'">
                  <span class="time"><i class="fa fa-clock-o"></i> {{ elapsedTime(entry.value.timestamp) }}</span>

                  <h3 class="timeline-header no-border"><b>{{entry.value.dealer.username.split('@')[0]}}</b>
                    <span v-if="entry.value.action === 'PUBLISH'"> ha publicado el vehículo:</span>
                    <span v-if="entry.value.action === 'CREATE_VEHICLE'"> ha creado un nuevo vehículo:</span>
                    <span v-if="entry.value.action === 'UPDATE_VEHICLE'"> ha actualizado el vehículo:</span>
                    <span v-if="entry.value.action === 'UNPUBLISH'"> ha despublicado el vehículo:</span>
                    <span v-if="entry.value.action === 'RESERVE'"> ha reservado el vehículo:</span>
                    <span v-if="entry.value.action === 'SOLD'"> ha vendido el vehículo:</span>
                    <span v-if="entry.value.action === 'DELETE_RESERVE'"> ha quitado la reserva del vehículo:</span>
                  </h3>

                  <div class="timeline-body">
                    <div class="post">
                      <div class="user-block">
                        <img class="img-circle" :src="urlForImage(entry.value.car.thumbnail)">
                        <span class="username">
                          <router-link tag="a" :to="{ name: 'edit_car', params: { carCode: entry.value.car.code }}">{{entry.value.car.fullText}}</router-link>
                        </span>
                        <span class="description">
                          <ul class="characteristics">
                            <li>{{ entry.value.car.type.name }}</li>
                            <li>{{ entry.value.car.price }} €</li>
                            <li>{{ entry.value.car.version.fueltype.name }}</li>
                            <li v-if="entry.value.car.plate !== ''">{{ entry.value.car.plate }}</li>
                            <li>{{ entry.value.car.kilometers }} km</li>
                          </ul>
                        </span>
                      </div>
                      <ul class="list-inline">
                        <li class="pull-right">
                          <div class="link-black text-sm"><i class="fa fa-home margin-r-5"></i>{{ entry.value.car.dealership.name }}</div>
                        </li>
                      </ul>
                    </div>
                  </div>

                </div>
            </li>

            <li v-if="timeline.length > 0">
              <i class="fa fa-clock-o bg-gray"></i>
            </li>

          </ul>
        </div>
      </div>

    </div>
  </section>
</div>
</template>

<style lang="scss" scoped>

  .container-fluid {
    min-width: 600px;
    min-height: 500px;
  }

  .overlay {
    min-height: 50px;
  }
  .timeline-item.load_more {
    max-width: 120px !important;
    text-align: center;
    padding: 2px;
  }

  .timeline-item {
    display: inline-block;
  }

  .timeline {

    .img-circle {
      width: 60px;
      height: 60px;
    }

    .username {
      padding-left: 20px;
    }

    .characteristics {
      list-style: none;
      padding-left: 20px !important;
      li:not(:first-child)::before {
        content: "\00a0|\00a0";
      }

      li {
        float: left;
      }
    }

    .badge_publish {
      background-color: #00b773;
      color: white;
    }
    .badge_unpublish {
      background-color: rgba(85, 85, 85, 0.92);
      color: white;
    }
    .badge_reserve {
      background-color: #b7b300;
      color: white;
    }
    .badge_sold {
      background-color: #00c0ef;
      color: white;
    }
    .badge_remove_reserve {
      background-color: #e2e3e5;
      color: #383d41;
    }
    .badge_create_vehicle {
      background-color: #0073b7;
      color: white;
    }
    .badge_update_vehicle {
      background-color: #605ca8;
      color: white;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/TimeLineComponent.vue